import Vue from 'vue';
import 'vue-i18n'; // 加载 vue-i18n 的类型增强，使 new Vue({ i18n }) 在 TS 下合法
import App from './App.vue';
import vhtml from 'vhtml-ui';
import router from '../../router/history';
import request, { setI18nForTran } from '../../utils/ajax';
import { PromiseHelperAllSettled } from '../../utils/Promise';
import filterMenuPage from './config';
import robotMenuHandle from '../../cgi/zhiku/api/menuHandler';
import { isSsc } from '../../cgi/zhiku/api/tools';
import i18n from '../../i18n';
import { applyLibLocale, onLibLocaleChange } from '../../utils/lib-locale-bridge/apply-lib-locale';
import { pageDataStore } from '@/components/page-data';
if (Promise && !Promise.allSettled) {
  Promise.allSettled = PromiseHelperAllSettled;
}

Vue.config.productionTip = false;
Vue.prototype.$ajax = request;
Vue.config.devtools = true;

// 接口数据国际化：把 i18n 实例交给 ajax 层。
// 之后所有业务请求会自动等翻译字典就绪后再发送（仅 en-US，单例幂等），业务无感。
setI18nForTran(i18n);

// 必须在 new Vue 之前：按当前 qidianLocale 同步到所有基础组件库
applyLibLocale();
// 订阅语言切换事件：默认整页刷新（vhtml / vhtml-market 的 locale 不是响应式）
onLibLocaleChange(() => location.reload());

Vue.use(vhtml);
if (window.QD_ADMIN_COMMON) {
  window.QD_ADMIN_COMMON.init({
    useNewMenu: true,
    skeletonId: 'app',
    menu: {
      menuClick: (e, v) => {
        console.log('[菜单]', v, router);
        // 匹配到路由使用
        if (router.matcher.match(v.originUrl).matched.length) {
          e.preventDefault();
          router.push(v.originUrl);
        }
      },
      menuListDataHandle: isSsc && filterMenuPage.includes(window.location.pathname) ? robotMenuHandle : undefined,
    },
  });
  QD_ADMIN_COMMON.on('dataReady', () => {
    pageDataStore.state.commonDataReady = true;
  });
}

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
